<template>
  <v-container class="mt-4 ml-2" fluid v-if="isPosadaDisponible">
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card class="pa-4 text-center">
          <div style="padding: 2rem; color: gray;">
            <h1>Confirma tu asistencia</h1>
          </div>
          <!-- Imagen de la invitación -->
          <v-img
            :src="invitacion"
            alt="Invitación a la posada"
            max-width="400"
            max-height="500"
            class="mx-auto"
          ></v-img>

          <!-- Checkboxes para responder sí/no -->
          <v-row class="mt-4" >
            <v-col cols="12" >
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;" >
                <div style="color: gray; text-align: center;">
                  <h3>¿Puedes asistir al evento?</h3>
                </div>
                <v-radio-group v-model="respuesta" row>
                  <v-radio :value="1" label="Sí"></v-radio>
                  <v-radio :value="0" label="No"></v-radio>
                </v-radio-group>
              </div>
            </v-col>
          </v-row>


          <!-- Botón enviar respuesta -->
          <v-btn
            color="primary"
            class="mt-4"
            @click="enviarRespuesta"
            :disabled="respuesta === null"
          >
            Enviar respuesta
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import invitacion from '@/assets/posada_invitacion.jpg'; // ajusta la ruta de tu invitación
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isPosadaDisponible: false,
      invitacion,
      respuesta: null, // null hasta que traigamos la respuesta del usuario
      id: null,
    };
  },

  computed:{

    ...mapGetters('login', ['getdatosUsuarioERPERP']),

  },
  async created() {
      //console.log( this.getdatosUsuarioERPERP )
      await this.posadaDisponible()
      await this.obtenerRespuestaUsuario()
    },
  methods: {
    posadaDisponible() {

      this.$http
        .get(`posada-disponible?id=${this.getdatosUsuarioERPERP.id_usuario}`)
        .then((response) => {

          this.isPosadaDisponible = !!response.data[0].resultado

        })
        .catch((error) => {
          console.error('Error al obtener respuesta:', error);
        });

    },
    obtenerRespuestaUsuario() {
      this.$http
        .get(`evento?id=${this.getdatosUsuarioERPERP.id_usuario}`)
        .then((response) => {
          //console.log('recibi respuesta')
          if (response.data.length) {
            // preseleccionamos la respuesta que ya dio el usuario
            this.respuesta = response.data[0].confirmacion; // 1 o 0
            this.id = response.data[0].id; // 1 o 0
            //console.log( this.respuesta )
          }
        })
        .catch((error) => {
          console.error('Error al obtener respuesta:', error);
        });
    },
    enviarRespuesta() {
      this.$http
        .post('evento-confirmacion', {
          confirmacion: this.respuesta,
          idusuario: this.getdatosUsuarioERPERP.id_usuario,
          idevento: 1,
          id: this.id
        })
        .then(() => {
          this.$swal({
            icon: 'success',
            title: 'Respuesta guardada',
            text:
              this.respuesta === 1
                ? 'Has confirmado tu asistencia.'
                : 'Has rechazado el evento.',
            confirmButtonText: 'Aceptar',
          });
        })
        .catch((error) => {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: error,
            confirmButtonText: 'Aceptar',
          });
        });
    },
  },
};
</script>
